/**
 * What each tab is for, in one place.
 *
 * Three of these name a concept staff meet here for the first time, and the
 * explanation shares a row with the tab's one action — an action row holding
 * nothing but a right-aligned button costs a whole band of the page to say
 * nothing.
 */
export const COMMS_HINTS = {
  segments: 'Segments update automatically as policyholder data changes — someone joins the moment they match, and drops out if they stop matching.',
  templates: 'Templates are reusable. Build one once, then use it across any number of sequences or a one-off send.',
  sequences: 'A sequence pairs one or more segments with a cadence of steps: Renewal Reminders for renewal-driven cadences, or Start from Scratch for events on their own calendar, like a weather alert.',
  send: "A message sent here goes immediately and doesn't touch anyone's place in a sequence. For urgent, time-sensitive updates only.",
  history: 'Every message actually sent, by email or as a message in the portal, including who sent it.',
};
